export default "__VITE_ASSET__6A$SbU4v__"